import { clientId } from "./constants";

export const businessPartnersRoutes = [
  {
    path: "/business-partners",
    name: "businessPartnersOverview",
    props: true,
    component: () =>
      import("@shared/businesspartners/views/ContactOverview.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "contacts",
          route: { name: "businessPartnersOverview" },
        },
      ],
    },
  },
  {
    path: "/business-partners/company/:id",
    name: "bpCompanyDetail",
    props: true,
    component: () =>
      import("@shared/businesspartners/views/ContactDetailCompany.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "contacts",
          route: { name: "businessPartnersOverview" },
        },
      ],
    },
  },
  {
    path: "/business-partners/person/:id",
    name: "bpPersonDetail",
    props: true,
    component: () =>
      import("@shared/businesspartners/views/ContactDetailPerson.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "contacts",
          route: { name: "businessPartnersOverview" },
        },
      ],
    },
  },
];
